import React, { useState } from 'react';
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput
} from 'mdb-react-ui-kit';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useMessageBox } from '../Common/MessageBox';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Country, City } from "country-state-city";
import { getDefaultCurrencyForCountry } from "../../utils/countryToCurrency";

function CompanyNameModal({ show, onClose, onSubmit, userName }) {
  const [formData, setFormData] = useState({
    company_name: '',
    country: '',
    city: '',
    address: '',
    postal_code: '',
    phone_number: ''
  });

  const [loading, setLoading] = useState(false);
  const { showWarning, MessageBoxComponent } = useMessageBox();

  const countries = Country.getAllCountries();
  const cities = City.getCitiesOfCountry(formData.country);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async () => {
    const { company_name, country, city, phone_number } = formData;

    if (!company_name || !country || !city) {
      showWarning("Please fill all required fields");
      return;
    }

    // Simple phone validation (E.164)
    if (phone_number && !isValidPhoneNumber(phone_number)) {
      showWarning("Invalid phone number");
      return;
    }

    setLoading(true);
    await onSubmit({
      ...formData,
      currency: getDefaultCurrencyForCountry(country),
    });
    setLoading(false);
  };

  return (
    <>
      <MDBModal open={show} staticBackdrop>
        <MDBModalDialog centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>👋 Welcome, {userName}</MDBModalTitle>
            </MDBModalHeader>

            <MDBModalBody>
              <p className="text-muted mb-3">
                Complete your business profile to continue
              </p>

              <MDBInput
                label="Company Name"
                id="company_name"
                size="lg"
                className="mb-3"
                value={formData.company_name}
                onChange={handleChange}
              />

                {/* COUNTRY */}
                <select
                  id="country"
                  className="form-control mb-3"
                  value={formData.country}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      country: e.target.value,
                      city: "" // reset city when country changes
                    });
                  }}
                >
                  <option value="">Select Country</option>
                  {countries.map((c) => (
                    <option key={c.isoCode} value={c.isoCode}>
                      {c.name}
                    </option>
                  ))}
                </select>


                {/* CITY */}
                <select
                  id="city"
                  className="form-control mb-3"
                  value={formData.city}
                  onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                  disabled={!formData.country}
                >
                  <option value="">Select City</option>
                  {cities.map((c) => (
                    <option key={c.name} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>

              <MDBInput
                label="Business Address"
                id="address"
                className="mb-3"
                value={formData.address}
                onChange={handleChange}
              />

              <MDBInput
                label="Postal Code"
                id="postal_code"
                className="mb-3"
                value={formData.postal_code}
                onChange={handleChange}
              />

              {/* Professional Phone Input */}
              <label className="mb-1 fw-bold">Phone Number</label>
              <PhoneInput
                  country={formData.country ? formData.country.toLowerCase() : "pk"}
                  value={formData.phone_number}
                  countryCodeEditable={false}
                  onChange={(phone) => {
                    setFormData({
                      ...formData,
                      phone_number: phone.startsWith("+") ? phone : `+${phone}`,
                    });
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '48px',
                    fontSize: '16px',
                  }}
                  containerClass="mb-3"
                />

            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn
                color="primary"
                onClick={handleSubmit}
                disabled={loading}
                style={{ width: '100%' }}
              >
                {loading ? 'Saving...' : 'Continue →'}
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MessageBoxComponent />
    </>
  );
}

export default CompanyNameModal;
